import logo from "assets/img/logo/logo_aig_login-2.png";
import axios from "axios";
import { Growl } from "primereact/growl";
import BlockUi from "react-block-ui";
import { SelectButton } from "primereact/selectbutton";

import React, { Component } from "react";
import { BootstrapTable, TableHeaderColumn } from "react-bootstrap-table";
import "react-bootstrap-table/dist/react-bootstrap-table-all.min.css";
import { Textbox } from "react-inputs-validation";
import LoadingScreen from "react-loading-screen";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import {
  Alert,
  Button,
  ButtonGroup,
  Card,
  CardBody,
  CardFooter,
  CardHeader,
  CardTitle,
  Col,
  Label,
  Row,
  ModalBody,
  ModalHeader,
  Modal,
  ModalFooter,
} from "reactstrap";
import {
  urlCOnsultaGuardarPersonas,
  urlConsultarCedula,
  urlObtenerExcel,
  urlObtenerPlanesAccPBase,
  urlObtenerPlanesAccPCrud,
  urlObtenerPlanesAccPCrudMasivo,
  urlObtenerPlanesAccPUpdateValues,
} from "../../../constants/urls";
import {
  FetchDataCarritoHogar,
  LimpiarCarritoHogar,
  setProductoActualCotizadoHogar,
} from "../../../redux/actions/ACarritoProductos";
import { fetchConsultarIdentificacionAP } from "../../../redux/actions/aCotizacion";
import { FetchPost } from "../../../redux/actions/api";
import ValoresCotizacionAccPersonal from "../ValoresCotizacionAccPersonal";
import ComponentTipoCarga from "../../CargaVidas/ComponentTipoCarga";
import ComponentCargaMasiva from "../../CargaVidas/ComponentCargaMasiva";
import { apiGet, apiPost2 } from "../../../api";
import ComponentPersonas from "../../CargaVidas/ComponentPersonas";
import { empresa } from "../../../constants";
class AgregarPersonas extends Component {
  constructor(props) {
    super(props);
    const queryParams = new URLSearchParams(this.props.location.search);
    this.state = {
      validate: false,
      identificacionSelected: "",
      nombreSelected: "",
      cargoSelected: "",
      identificacionHasError: false,
      nombreHasError: false,
      cargoHasError: false,
      loading: false,
      value: 'masiva',
      errores: [],
      plantillaConError: false,
      msgValidarPersona: false,
      finalizarIngresoIdentificaciones: true,
      itemActualizarReact: undefined,
      idCarrito: queryParams.get("id"),
      numPersonasIngresar: 0, //verificar
      numPersonasIngresarSecundario: 0, //verificar
      habilitarGuardarInformacion: true,
      //EdadMaximaAdmitida: undefined,
      EdadMaximaAdmitida: 60, //verificar
      fechaNacimientoSelected: "",
      fechaHasError: false,
      verMsgEdad: false,
      planContratista: [],
      planGuardias: [],
      planGuarderias: [],
      personas: [],
      columnas: [],
      planPymes: { Administrativos: [], Operativos: [] },
      tabFirst: true,
      datosPlantilla: {
        "urlPlantilla": "",
        "columnas": []
      },

      planes: [],
      opcionSeleccionada: null,
      actualizado: false,
      viewactualizar: true,
      message: "¿Está seguro de realizar esta operación?",
      transaccion: false,
      modal: false,
      blockui: false,
    };
    this.cargarInfoCards = this.cargarInfoCards.bind(this);
  }

  componentDidMount() {
    if (
      this.props.planesCotizacionAccP &&
      this.props.planesCotizacionAccP.msgConfirmarRecalculo &&
      this.props.planesCotizacionAccP.msgConfirmarRecalculo.length > 0
    ) {
      console.log(
        "message",
        this.props.planesCotizacionAccP.msgConfirmarRecalculo
      );
      this.setState({
        message: this.props.planesCotizacionAccP.msgConfirmarRecalculo,
      });
    }
    this.obtenerExcel()
    this.cargarInfoCards();
  }
  itemTemplate = (option) => {
    console.log(option);
    return (
      <div
        className="container w-100"
        style={{
          width: "100%",
          border: "1px solid black",
          borderRadius: "4px",
        }}
        key={option.codigo}
      >
        <small
          style={{ fontSize: "14px", marginTop: "2px", marginBottom: "2px" }}
        >
          {option.nombreSubPlan}
        </small>
        <br />
        <strong style={{ fontSize: "15px", marginBottom: "2px" }}>
          {option.opcion}
        </strong>
      </div>
    );
  };
  Modal = (boolean) => {
    this.setState({ modal: boolean });
  };
  cargarInfoCards = async () => {
    const url =
      urlObtenerPlanesAccPBase +
      "&idCarrito=" +
      (this.state.idCarrito != undefined && this.state.idCarrito != null
        ? this.state.idCarrito
        : this.props.idCarrito);
    const customHeaders = {
      "content-type": "application/json",
    };

    axios
      .get(url, customHeaders)
      .then((response) => {
        let data = response.data;
        console.log("Consulta API before", data);
        const dataplan = this.props.planActual
          ? this.props.planActual.plan.name
          : "";


        const plan = data.planElegido;

        const subplan = data.subPlan;


        if (dataplan === "Guardias") {
          const data = [];
          if (plan[0]) {
            let registro = plan[0].Guardias[0];
            registro.subPlan = subplan;
            data.push({ ...registro });
          }
          if (plan[1]) {
            let registro = plan[1].Guardias[0];
            registro.subPlan = subplan;
            data.push({ ...registro });
          }
          this.setState({ planGuardias: data });
          console.log("PlanGuardias", this.state.planGuardias);
          this.filterdata(data);
        } else if (dataplan === "Guarderías") {
          const data = [];
          if (plan[0]) {
            let registro = plan[0].Guarderías[0];
            registro.subPlan = subplan;
            data.push({ ...registro });
          }
          if (plan[1]) {
            let registro = plan[1].Guarderías[0];
            registro.subPlan = subplan;
            data.push({ ...registro });
          }
          this.setState({
            planGuarderias: data,
          });
          console.log("planGuarderias", this.state.planGuarderias);
          this.filterdata(data);
        } else if (dataplan === "Contratistas") {
          const data = [];
          if (plan[0]) {
            let registro = plan[0].Contratistas[0];
            registro.subPlan = subplan;
            data.push({ ...registro });
          }
          this.setState({ planContratista: data });
          console.log("planContratista", this.state.planContratista);
          this.filterdata(data);
        } else if (dataplan === "Pymes") {

          const Administrativos = [];
          const Operativos = [];



          if (plan.Pymes) {


            let arrayAux = []

            if (Array.isArray(plan.Pymes)) {

              arrayAux = plan.Pymes

            } else {
              for (const key in plan.Pymes['1']) {

                arrayAux.push({ [key]: plan.Pymes['1'][key] })

              }

            }


            console.log('dataplan', arrayAux)



            arrayAux.forEach((planes) => {



              if (planes.Administrativos != undefined) {


                planes.Administrativos.forEach((plan) => {
                  let registro = plan;
                  registro.subPlan = subplan;
                  registro.nombreSubPlan = "Administrativos";
                  Administrativos.push({ ...registro });
                });
              }



              if (planes.Operativos != undefined) {
                planes.Operativos.forEach((plan) => {
                  let registro = plan;
                  registro.subPlan = subplan;
                  registro.nombreSubPlan = "Operativos";
                  Operativos.push({ ...registro });
                });
              }


            });


          }

          const data = {
            Administrativos: Administrativos,
            Operativos: Operativos,
          };

          console.log('verlog', data)
          this.setState({
            planPymes: data,
          });
          console.log("planPymes", this.state.planPymes);
          this.filterdata(data);
        } else if (dataplan === "AIGMED") {
          const data = [];
          if (plan[0] != undefined && plan[0].AIGMED !== undefined) {
            plan[0].AIGMED.forEach((plan) => {
              let registro = plan;
              registro.subPlan = subplan;
              data.push({ ...registro });
            });
            this.setState({ planAigmed: data });
            console.log("planAigmed", this.state.planAigmed);
            this.filterdata(data);
          }
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  filterdata = (data) => {
    console.log("data222", data);
    var _this = this;
    if (
      this.state.opcionSeleccionada != null &&
      this.state.planPymes.Administrativos.length === 0 &&
      this.state.planPymes.Operativos.length === 0
    ) {
      data.forEach((e) => {
        if (e.opcion == this.state.opcionSeleccionada.opcion) {
          _this.setState({
            opcionSeleccionada: e,
            numPersonasIngresar: e.numPersonas,
          });
        }
      });
    } else {
      if (
        this.state.opcionSeleccionada != null &&
        data.Administrativos &&
        data.Administrativos.length > 0
      ) {
        data.Administrativos.forEach((e) => {
          if (
            e.opcion == this.state.opcionSeleccionada.opcion &&
            e.nombreSubPlan === this.state.opcionSeleccionada.nombreSubPlan
          ) {
            _this.setState({
              opcionSeleccionada: e,
              numPersonasIngresar: e.numPersonas,
            });
          }
        });
      }
      if (
        this.state.opcionSeleccionada != null &&
        data.Operativos &&
        data.Operativos.length > 0
      ) {
        data.Operativos.forEach((e) => {
          if (
            e.opcion == this.state.opcionSeleccionada.opcion &&
            e.nombreSubPlan === this.state.opcionSeleccionada.nombreSubPlan
          ) {
            _this.setState({
              opcionSeleccionada: e,
              numPersonasIngresar: e.numPersonas,
            });
          }
        });
      }
    }
  };

  guardarMasivo = () => {
    this.onAgregarPersonasMasivo()
  }

  actualizarValores = async (validarMinimo = true) => {


    axios
      .get(urlObtenerPlanesAccPUpdateValues, {
        params: {
          idCarrito:
            this.state.idCarrito != undefined && this.state.idCarrito != null
              ? this.state.idCarrito
              : this.props.idCarrito,
          empresa: "AIGMETROPOLITANA",
          validarMinimo: validarMinimo ? 1 : 0
        },
      })
      .then((response) => {
        const data = response.data;
        if (data.transaccion) {
          this.props.recuperarCarrito();
          this.cargarInfoCards();
          this.setState({ actualizado: false, transaccion: true });
        } else {
          if (data.errorDescripcion && data.errorDescripcion.length > 0) {
            this.showWarn(data.errorDescripcion.toString());
          }
        }
      })
      .catch((error) => {
        console.log(error);
      });

  };
  toggleValidating(validate) {
    this.setState({ validate });
  }
  GuardarInformacion = () => {
    alert("API ACC Personales");
  };

  obtenerExcel = async () => {

    this.setState({ loading: true })



    const resultado = await apiGet(urlObtenerExcel + 'ap')

    if (resultado.transaccion) {
      this.setState({ datosPlantilla: resultado })

    }



    this.setState({ loading: false })


  }

  onValidateform = async () => {
    const {
      datosItem,
      finalizarIngresoIdentificaciones,
      itemActualizarReact,
      idCarrito,
    } = this.state;
    if (datosItem.length > 0) {
      let { loading } = this.state;
      this.setState({ loading: true });
      let resp = await FetchPost({
        url: urlCOnsultaGuardarPersonas,
        param: {
          empresa: "AIGMETROPOLITANA",
          idCarrito:
            this.state.idCarrito != undefined && this.state.idCarrito != null
              ? this.state.idCarrito
              : this.props.idCarrito,
          datosActualizar: {
            index: itemActualizarReact.nroItem,
            codigoUbicacion: itemActualizarReact.codigo,
            datosPersonas: datosItem,
          },
        },
      });
      const { transaccion } = resp;
      if (transaccion) {
        //Validar si existen items que se deban ingresar
        if (
          finalizarIngresoIdentificaciones &&
          finalizarIngresoIdentificaciones === true
        ) {
          this.props.history.push({
            pathname: "/final-cotizacionbroker",
            search: `?ramo=HOG`,
          });
        } else {
          //inicializar los estados del formulario
          this.setState({
            validate: false,
            identificacionSelected: "",
            nombreSelected: "",
            datosItem: [],
            identificacionHasError: false,
            nombreHasError: false,
            loading: false,
            msgValidarPersona: false,
            finalizarIngresoIdentificaciones: true,
            itemActualizarReact: undefined,
            numPersonasIngresar: 0,
            habilitarGuardarInformacion: true,
          });
          this.onCargarProductosIngresar();
        }
      }
      this.setState({ loading: false });
    } else {
      this.setState({ msgValidarPersona: true });
    }
  };

  onObtenerEdadPersona(fecha) {
    const answer_array = fecha.split("/");
    let fechaCalculoEdad = `${answer_array[2]}-${answer_array[1]}-${answer_array[0]}`;
    //Calcular edad de la persona ingresada
    let hoy = new Date();
    let cumpleanos = new Date(fechaCalculoEdad);
    let edad = hoy.getFullYear() - cumpleanos.getFullYear();
    let m = hoy.getMonth() - cumpleanos.getMonth();
    if (m < 0 || (m === 0 && hoy.getDate() < cumpleanos.getDate())) {
      edad--;
    }
    return edad;
  }

  onAgregarPersonasMasivo = async () => {
    this.setState({ loading: true })
    let {
      identificacionSelected,
      nombreSelected,
      fechaNacimientoSelected,
      nombreHasError,
      fechaHasError,
      numPersonasIngresar,
      EdadMaximaAdmitida,
      cargoHasError,
      cargoSelected,
      personas
    } = this.state;
    let valoractualPersonas = numPersonasIngresar;
    if (
      personas.length > 0
    ) {
      const body = {
        idCarrito:
          this.state.idCarrito != undefined && this.state.idCarrito != null
            ? this.state.idCarrito
            : this.props.idCarrito,
        opcionElegida: this.state.opcionSeleccionada.opcion,
        empresa: empresa,
        planElegido: this.props.planActual.plan.name,
        action: "agregar",
        subplan: this.state.opcionSeleccionada.subPlan
          ? this.state.opcionSeleccionada.nombreSubPlan
          : "",

        datosPersonas: personas.map(persona => { return { identificacion: persona['IDENTIFICACION'], nombre: persona['NOMBRE Y APELLIDO'], cargo: persona['CARGO'], fechaNacimiento: persona['fechaNacimiento'] } })
      };
      console.log('personasAguardar', personas)

      const resultado = await apiPost2(urlObtenerPlanesAccPCrudMasivo, body)
      this.setState({ loading: false })



      const valoresConError = resultado.resultadoAgregarAsegurado.filter(r => r.resultado.transaccion == false)

      if (resultado.transaccion) {

        this.setState({ modal: false });
        this.cargarInfoCards();

        this.vaciaCampos();
        this.setState({ personas: [], errores: valoresConError })


      } else {

      }



    }
  };

  onAgregarPersonas = async (type) => {
    console.log("Agregar");
    let {
      identificacionSelected,
      nombreSelected,
      fechaNacimientoSelected,
      nombreHasError,
      fechaHasError,
      numPersonasIngresar,
      EdadMaximaAdmitida,
      cargoHasError,
      cargoSelected,
    } = this.state;
    let valoractualPersonas = numPersonasIngresar;
    if (
      nombreHasError === false &&
      fechaHasError === false &&
      fechaNacimientoSelected !== "" &&
      nombreSelected !== "" &&
      valoractualPersonas > 0
    ) {
      let registroNuevo = {
        //id: ui(),
        nombre: nombreSelected,
        apellido: " ",
        idCarrito:
          this.state.idCarrito != undefined && this.state.idCarrito != null
            ? this.state.idCarrito
            : this.props.idCarrito,
        identificacion: identificacionSelected,
        fechnac: fechaNacimientoSelected,
        cargo: cargoSelected,
        opcionElegida: this.state.opcionSeleccionada.opcion,
        planElegido: this.props.planActual.plan.name,
        action: "agregar",
        subplan: this.state.opcionSeleccionada.subPlan
          ? this.state.opcionSeleccionada.nombreSubPlan
          : "",
      };
      //datosAnteriores.push(registroNuevo);
      // this.props.addPersonas(registroNuevo, type);
      console.log("DataSend", registroNuevo);
      const customHeaders = {
        "content-type": "application/json",
      };
      var _this = this;
      axios
        .get(urlObtenerPlanesAccPCrud, { params: { ...registroNuevo } })
        .then((response) => {
          console.log("Result ADD", response.data);
          const data = response.data;
          if (data.transaccion) {
            _this.setState({ modal: false });
            _this.cargarInfoCards();

            this.vaciaCampos();
          } else {
            if (data.errorDescripcion && data.errorDescripcion.length > 0) {
              _this.setState({ modal: false });
              this.showWarn(data.errorDescripcion.toString());
            }
          }

          //this.obtenerNumeroPersonasIngresar();
        })
        .catch((error) => {
          console.log(error);
        });

      this.setState({ actualizado: true });

      /*let resp = await apiPost(urlObtenerPlanesAccPCrud, registroNuevo);
          console.log("registroNuevo", resp);*/
    }
  };

  obtenerNumeroPersonasIngresar = () => {
    this.setState({
      numPersonasIngresar:
        this.state.opcionSeleccionada != null
          ? this.state.opcionSeleccionada.numPersonas -
            this.state.opcionSeleccionada.Personal
            ? this.state.opcionSeleccionada.Personal.length
            : 0
          : 0,
    });
  };
  cancelar = () => {
    console.log("databutton");
    this.props.changeVista(ConstVista.vistaResumen);
  };
  vaciaCampos = () => {
    this.setState({
      identificacionSelected: "",
      nombreSelected: "",
      fechaNacimientoSelected: "",
      cargoSelected: "",
      msgValidarPersona: false,
      validate: false,
      verMsgEdad: false,
    });
    // this.obtenerNumeroPersonasIngresar();
  };

  onEliminarElemento = (datatable, type) => {
    let registro = {
      //id: ui(),
      nombre: datatable.nombre,
      apellido: datatable.apellido,
      idCarrito:
        this.state.idCarrito != undefined && this.state.idCarrito != null
          ? this.state.idCarrito
          : this.props.idCarrito,
      identificacion: datatable.identificacion,
      fechnac: datatable.fechnac,
      cargo: datatable.cargo,
      opcionElegida: this.state.opcionSeleccionada.opcion,
      planElegido: this.props.planActual.plan.name,
      action: "borrar",
      subplan: this.state.opcionSeleccionada.subPlan
        ? this.state.opcionSeleccionada.nombreSubPlan
        : "",
    };
    axios
      .get(urlObtenerPlanesAccPCrud, { params: { ...registro } })
      .then((data) => {
        console.log("Result Eliminar", data);
        this.cargarInfoCards();
      })
      .catch((error) => {
        console.log(error);
      });

    this.setState({ actualizado: true });
    const _this = this;
    //this.props.onRemovePersonas(datatable, type);

    this.setState({
      msgValidarPersona: false,
      verMsgEdad: false,
    });
    setTimeout(function () {
      // _this.obtenerNumeroPersonasIngresar();
    }, 1000);
  };
  Secuencial(cell, row, enumObject, index) {
    return <div>{index + 1}</div>;
  }
  generarBotonesDetalles = (cell, row) => {
    const _this = this;
    return (
      <div>
        <Button
          className={"button-white"}
          style={{ marginRight: "0.2em" }}
          onClick={() => {
            if (
              window.confirm(
                `Esta acción eliminará el registro, ¿Desea continuar?`
              )
            ) {
              if (_this.state.tabFirst) {
                _this.onEliminarElemento(row, ConstVista.listaPrincipal);
              } else {
                _this.onEliminarElemento(row, ConstVista.listaSecundaria);
              }
            }
          }}
        >
          {" "}
          <i className="fa fa-trash-alt" aria-hidden="true" /> ELIMINAR
        </Button>
      </div>
    );
  };
  onConsultarCedula = async (identificacion) => {
    this.setState({ blockui: true });
    let resp = await FetchPost({
      url: urlConsultarCedula + identificacion,
      param: {},
    });
    const { transaccion, nombre, fecha_nacimiento } = resp;
    if (transaccion) {
      this.setState({
        nombreSelected: nombre,
        fechaNacimientoSelected: fecha_nacimiento,
      });
      this.setState({ blockui: false });
    } else {
      this.setState({
        nombreSelected: "",
        fechaNacimientoSelected: "",
        cargoSelected: "",
      });
      this.setState({ blockui: false });
    }

    this.toggleValidating(true);
  };

  onSelect = (value) => {
    console.log("selected", value);

    this.setState({
      opcionSeleccionada: value,
      numPersonasIngresar:
        value && value.numPersonas != null && value.numPersonas
          ? parseInt(value.numPersonas)
          : 0,
    });
    // this.obtenerNumeroPersonasIngresar();
  };
  showWarn = (message) => {
    this.growl.show({
      severity: "info",
      summary: "Información",
      detail: message,
    });
  };
  render() {
    let styleobj = { fontSize: 15 };
    let filterobj = { type: "TextFilter", delay: 500 };
    let styletable = { whiteSpace: "normal", fontSize: 14 };
    const options = { noDataText: "No existen datos registrados" };
    let {
      identificacionSelected,
      nombreSelected,
      validate,
      loading,
      msgValidarPersona,
      itemActualizarReact,
      numPersonasIngresar,
      fechaNacimientoSelected,
      EdadMaximaAdmitida,
      verMsgEdad,
      cargoSelected,
      planes,
    } = this.state;
    let nroitem =
      itemActualizarReact && itemActualizarReact.nroItem
        ? parseInt(itemActualizarReact.nroItem)
        : 0;
    nroitem = nroitem + 1;
    return (
      <LoadingScreen
        loading={loading}
        bgColor="#f1f1f1"
        spinnerColor="#001871"
        textColor="#676767"
        logoSrc={logo}
        text="Buscando Información de Persona..."
      >
        <Growl ref={(el) => (this.growl = el)} life="5000" />
        <Row>
          <Col>
            <div>
              <Card>
                <CardHeader>
                  {" "}
                  <strong> PLAN: </strong>{" "}
                  {this.props.planActual &&
                    this.props.planActual.plan &&
                    this.props.planActual.plan.descripcion
                    ? this.props.planActual.plan.descripcion.toUpperCase()

                    : ""}
                </CardHeader>
                <CardBody>
                  <CardTitle>
                    <Row>
                      <Col lg={12} md={12} sm={12} xs={12}>
                        {this.state.opcionSeleccionada != null ? (
                          <div></div>
                        ) : (
                          <div>
                            <Alert
                              color="warning"
                              style={{ textAlign: "center", width: "100%" }}
                            >
                              Seleccione una opción para iniciar el proceso de
                              registro de personas aseguradas
                            </Alert>
                          </div>
                        )}
                        <ButtonGroup aria-label="Basic example">
                          {this.state.planAigmed != null && (
                            <SelectButton
                              optionLabel="opcion"
                              value={this.state.opcionSeleccionada}
                              options={this.state.planAigmed}
                              style={{ border: "1px solid #dee2e6" }}
                              onChange={(e) => {
                                this.onSelect(e.value)
                                this.setState({ personas: [] })
                              }}
                            ></SelectButton>
                          )}
                          {this.state.planGuarderias != null && (
                            <SelectButton
                              optionLabel="opcion"
                              value={this.state.opcionSeleccionada}
                              options={this.state.planGuarderias}
                              style={{ border: "1px solid #dee2e6" }}
                              onChange={(e) => {
                                this.onSelect(e.value)
                                this.setState({ personas: [] })
                              }}
                            ></SelectButton>
                          )}
                          {this.state.planContratista != null && (
                            <SelectButton
                              optionLabel="opcion"
                              value={this.state.opcionSeleccionada}
                              options={this.state.planContratista}
                              onChange={(e) => {
                                this.onSelect(e.value)
                                this.setState({ personas: [] })
                              }}
                            ></SelectButton>
                          )}

                          {this.state.planGuardias != null && (
                            <SelectButton
                              optionLabel="label"
                              value={this.state.opcionSeleccionada}
                              options={this.state.planGuardias}
                              onChange={(e) => {
                                this.onSelect(e.value)
                                this.setState({ personas: [] })
                              }}
                            ></SelectButton>
                          )}

                          {this.state.planPymes != null &&
                            this.state.planPymes.Administrativos.length > 0 && (
                              <SelectButton
                                optionLabel="opcion"
                                value={this.state.opcionSeleccionada}
                                options={this.state.planPymes.Administrativos}
                                onChange={(e) => {
                                  this.onSelect(e.value)
                                  this.setState({ personas: [] })
                                }}
                                itemTemplate={this.itemTemplate}
                              ></SelectButton>
                            )}

                          {this.state.planPymes != null &&
                            this.state.planPymes.Operativos.length > 0 && (
                              <SelectButton
                                optionLabel="opcion"
                                value={this.state.opcionSeleccionada}
                                options={this.state.planPymes.Operativos}
                                onChange={(e) => {
                                  this.onSelect(e.value)
                                  this.setState({ personas: [] })
                                }}
                                itemTemplate={this.itemTemplate}
                              ></SelectButton>
                            )}

                        </ButtonGroup>
                      </Col>
                    </Row>
                  </CardTitle>
                  <Row>
                    <Col>
                      {this.state.opcionSeleccionada != null && (
                        <Alert
                          style={{ fontSize: 15, textAlign: "justify" }}
                          color="info"
                          isOpen={this.state.visibleAlert}
                          toggle={this.onDismiss}
                          className="text-align: justify;"
                        >
                          <p>
                            Por favor ingresar la información de identificación
                            (opcional), nombres y fecha de nacimiento de las
                            personas que habitan en la Ubicación Asegurada. Por
                            favor verifique que la información ingresada sea
                            correcta antes de presionar el botón "ACTUALIZAR".
                          </p>
                        </Alert>
                      )}
                    </Col>
                  </Row>

                  {this.state.opcionSeleccionada != null &&
                    <Row>
                      <Col>
                        <ComponentTipoCarga
                          value={this.state.value}
                          productoSeleccionado={null}
                          setValue={(value) => {
                            this.setState({ value: value })
                          }}
                        />
                      </Col>
                    </Row>
                  }

                  {(this.state.opcionSeleccionada != null) && (
                    <Row>
                      <Col sm={4}>
                        <Label
                          style={styleobj}
                          for="exampleSelect"
                          className="bold-font-label"
                        >
                          Nro. Personas a Ingresar
                        </Label>
                      </Col>
                      <Col sm={8}>{this.state.numPersonasIngresar}</Col>
                    </Row>
                  )}
                  {" "}



                  {this.state.opcionSeleccionada != null && this.state.value == "masiva" &&
                    <div>
                      <ComponentCargaMasiva
                        datosPlantilla={this.state.datosPlantilla}
                        setDatos={(datos) => {
                          console.log('valorPersonas', parseInt(this.state.numPersonasIngresar), datos.slice(0, parseInt(this.state.numPersonasIngresa)))
                          this.setState(
                            {
                              personas: datos.slice(0, parseInt(this.state.numPersonasIngresar)),
                              errores: []

                            }
                          )

                        }}
                        plantillaConError={this.state.plantillaConError}
                        setPlantillaConError={(valor) => { this.setState({ plantillaConError: valor }) }}
                        setColumnas={(datos) => this.setState({ columnas: datos })}
                      />

                      {this.state.errores.length > 0 &&

                        this.state.errores.map(error => {
                          return (
                            <Alert color="warning">{error.resultado.errorDescripcion}</Alert>
                          )
                        })
                      }

                      {this.state.personas.length > 0 &&
                        <ComponentPersonas
                          personas={this.state.personas}
                          mostrarErrores={true}
                          cerrado={true}
                          estaDuplicada={false}
                          plan={this.state.opcionSeleccionada.opcion}
                          setPersonas={(valor) => {

                            this.setState({ personas: valor })
                          }}
                        />

                      }





                      <hr></hr>
                    </div>


                  }

                  <Row>
                    <Col sm={4}>
                      {(this.state.numPersonasIngresar !== 0 && this.state.value == "manual") && (
                        <Button
                          onClick={() => this.Modal(true)}
                          className="btn btn-primary btn btn-secondary"
                        >
                          <i className="fa fa-plus-circle" aria-hidden="true" />
                          {` NUEVO`}
                        </Button>
                      )}
                    </Col>
                    <Col sm={8}></Col>
                  </Row>
                  <Modal
                    size="lg"
                    isOpen={this.state.modal}
                    modal={false}
                    toggle={() => this.Modal(false)}
                  >
                    <BlockUi
                      tag="div"
                      blocking={this.state.blockui}
                      message="Buscando Información de Persona..."
                    >
                      <ModalHeader toggle={() => this.Modal(false)}>
                        <strong>
                          <Label
                            style={styleobj}
                            for="exampleSelect"
                            className="bold-font-label"
                          >
                            Opción Seleccionada:
                          </Label>
                        </strong>
                        &nbsp;
                        <strong>
                          <Label
                            style={styleobj}
                            for="exampleSelect"
                            className="bold-font-label"
                          >
                            {this.state.opcionSeleccionada != null
                              ? this.state.opcionSeleccionada.opcion
                              : ""}
                          </Label>
                        </strong>
                      </ModalHeader>
                      <ModalBody>
                        <Card>
                          {this.state.opcionSeleccionada != null && (
                            <CardBody>
                              <Row>
                                <Col>
                                  <Row>
                                    <Col sm={4}>
                                      <strong>
                                        <Label
                                          style={styleobj}
                                          for="exampleSelect"
                                          className="bold-font-label"
                                        >
                                          Identificación
                                        </Label>
                                      </strong>
                                    </Col>
                                    <Col sm={8}>
                                      <Textbox
                                        tabIndex="1"
                                        type="input"
                                        value={identificacionSelected}
                                        name="identificacion"
                                        id="identificacion"
                                        placeholder="Ingrese la cédula de la persona Ejemplo (0105613045)."
                                        classNameInput={"form-control"}
                                        onChange={(identificacion, e) => {
                                          this.setState({
                                            identificacionSelected: identificacion,
                                          });
                                          if (identificacion.length === 10) {
                                            this.onConsultarCedula(
                                              identificacion
                                            );
                                          }
                                        }}
                                        //validate={validate}
                                        validationCallback={(res) =>
                                          this.setState({
                                            validate: res,
                                            identificacionHasError: res,
                                          })
                                        }
                                        onBlur={(e) =>
                                          this.setState({ blur: true })
                                        }
                                        validationOption={{
                                          name: "Identificación",
                                          reg: /^[0-9]+(\.[0-9]+)?$/,
                                          msgOnError:
                                            "El número de cédula ingresado es incorrecto.",
                                        }}
                                      />
                                    </Col>
                                  </Row>

                                  <Row>
                                    <Col sm={4}>
                                      <h5>
                                        <Label
                                          style={styleobj}
                                          for="exampleSelect"
                                          className="bold-font-label"
                                        >
                                          Nombre (*)
                                        </Label>
                                      </h5>
                                    </Col>
                                    <Col sm={8}>
                                      <Textbox
                                        tabIndex="1"
                                        type="input"
                                        value={nombreSelected}
                                        name="nombre"
                                        id="nombre"
                                        placeholder="Ingrese apellidos y nombres de la persona"
                                        classNameInput={"form-control"}
                                        onChange={(nombre, e) => {
                                          this.setState({
                                            nombreSelected: nombre.toUpperCase(),
                                          });
                                        }}
                                        validate={validate}
                                        validationCallback={(res) =>
                                          this.setState({
                                            validate: res,
                                            nombreHasError: res,
                                          })
                                        }
                                        onBlur={(e) =>
                                          this.setState({ blur: true })
                                        }
                                        validationOption={{
                                          name: "Nombres",
                                          check: true,
                                          required: true,
                                          msgOnError:
                                            "Debe ingresar apellidos y nombres de la persona",
                                        }}
                                      />
                                    </Col>
                                  </Row>

                                  <Row>
                                    <Col sm={4}>
                                      <Label
                                        style={styleobj}
                                        for="exampleSelect"
                                        className="bold-font-label"
                                      >
                                        Fecha de Nacimiento(*) (día/mes/año){" "}
                                      </Label>
                                    </Col>
                                    <Col sm={8}>
                                      <Textbox
                                        tabIndex="1"
                                        type="input"
                                        value={fechaNacimientoSelected}
                                        name="fechanacimiento"
                                        id="fechanacimiento"
                                        placeholder="Ingrese una Fecha Ej. 25/11/1985"
                                        classNameInput={"form-control"}
                                        onChange={(fecha, e) => {
                                          this.setState({
                                            fechaNacimientoSelected: fecha,
                                          });
                                        }}
                                        validate={validate}
                                        validationCallback={(res) =>
                                          this.setState({
                                            validate: res,
                                            fechaHasError: res,
                                          })
                                        }
                                        onBlur={(e) =>
                                          this.setState({ blur: true })
                                        }
                                        validationOption={{
                                          name: "fechanacimiento",
                                          check: true,
                                          required: true,
                                          reg: /^([0-2][0-9]|(3)[0-1])(\/)(((0)[0-9])|((1)[0-2]))(\/)\d{4}$/,
                                          msgOnError:
                                            "Debe ingresar una fecha de nacimiento válida en formato día/mes/año Ej.25/09/1985", // Optional.[Bool].Default: true. To determin if it is a required field.
                                        }}
                                      />
                                    </Col>
                                  </Row>

                                  <Row>
                                    <Col sm={4}>
                                      <h5>
                                        <Label
                                          style={styleobj}
                                          for="exampleSelect"
                                          className="bold-font-label"
                                        >
                                          Cargo (*)
                                        </Label>
                                      </h5>
                                    </Col>
                                    <Col sm={8}>
                                      <Textbox
                                        tabIndex="1"
                                        type="input"
                                        value={cargoSelected}
                                        name="cargo"
                                        id="cargo"
                                        placeholder="Ingrese el cargo de la persona"
                                        classNameInput={"form-control"}
                                        onChange={(cargo, e) => {
                                          this.setState({
                                            cargoSelected: cargo.toUpperCase(),
                                          });
                                        }}
                                        validate={validate}
                                        validationCallback={(res) =>
                                          this.setState({
                                            validate: res,
                                            cargoHasError: res,
                                          })
                                        }
                                        onBlur={(e) =>
                                          this.setState({ blur: true })
                                        }
                                        validationOption={{
                                          name: "Cargo",
                                          check: true,
                                          required: true,
                                          msgOnError:
                                            "Debe ingresar el cargo de la persona",
                                        }}
                                      />
                                    </Col>
                                  </Row>

                                  {verMsgEdad && verMsgEdad === true && (
                                    <Row>
                                      <Alert
                                        color="warning"
                                        isOpen={this.state.visibleAlert}
                                        toggle={this.onDismiss}
                                      >
                                        <center>
                                          <p>{`La persona ingresada no debe ser mayor a ${EdadMaximaAdmitida} años. Por favor `}</p>
                                        </center>
                                      </Alert>
                                    </Row>
                                  )}

                                  {msgValidarPersona &&
                                    msgValidarPersona === true && (
                                      <Row>
                                        <Alert
                                          color="warning"
                                          isOpen={this.state.visibleAlert}
                                          toggle={this.onDismiss}
                                        >
                                          <center>
                                            <p>
                                              Para continuar debe ingresar la
                                              información de al menos de una
                                              persona.
                                            </p>
                                          </center>
                                        </Alert>
                                      </Row>
                                    )}
                                  <br />
                                </Col>
                              </Row>
                            </CardBody>
                          )}
                        </Card>
                      </ModalBody>
                      <ModalFooter>
                        <Row>
                          <Col>
                            {this.state.numPersonasIngresar !== 0 && (
                              <div>
                                <Button
                                  onClick={() =>
                                    this.onAgregarPersonas(
                                      ConstVista.listaPrincipal
                                    )
                                  }
                                  className="btn btn-primary btn btn-secondary"
                                >
                                  <i
                                    className="fa fa-plus-circle"
                                    aria-hidden="true"
                                  />
                                  {` AGREGAR`}
                                </Button>
                                &nbsp;
                                <Button
                                  className="btn btn-detail-white"
                                  onClick={() => this.Modal(false)}
                                >
                                  CANCELAR
                                </Button>
                              </div>
                            )}
                          </Col>
                        </Row>
                      </ModalFooter>
                    </BlockUi>
                  </Modal>
                  {this.state.opcionSeleccionada != null && (
                    <BootstrapTable
                      data={
                        this.state.opcionSeleccionada != null &&
                          this.state.opcionSeleccionada.Personal
                          ? this.state.opcionSeleccionada.Personal
                          : []
                      }
                      striped
                      hover
                      pagination
                      options={options}
                    >
                      <TableHeaderColumn
                        style={{ width: "4%" }}
                        dataField="any"
                        tdStyle={styletable}
                        thStyle={styletable}
                        dataFormat={this.Secuencial}
                      >
                        #
                      </TableHeaderColumn>
                      <TableHeaderColumn
                        filter={filterobj}
                        tdStyle={styletable}
                        thStyle={styletable}
                        dataField="identificacion"
                        isKey
                      >
                        Identificación
                      </TableHeaderColumn>
                      <TableHeaderColumn
                        filter={filterobj}
                        tdStyle={styletable}
                        thStyle={styletable}
                        dataField="nombre"
                      >
                        Nombres
                      </TableHeaderColumn>
                      <TableHeaderColumn
                        filter={filterobj}
                        tdStyle={styletable}
                        thStyle={styletable}
                        dataField="fechnac"
                      >
                        Fecha Nacimiento
                      </TableHeaderColumn>
                      <TableHeaderColumn
                        filter={filterobj}
                        tdStyle={styletable}
                        thStyle={styletable}
                        dataField="cargo"
                      >
                        Cargo
                      </TableHeaderColumn>
                      <TableHeaderColumn
                        dataField="any"
                        tdStyle={styletable}
                        thStyle={styletable}
                        dataFormat={this.generarBotonesDetalles}
                      ></TableHeaderColumn>
                    </BootstrapTable>
                  )}
                </CardBody>
                <CardFooter>
                  <div align="right">
                    <button
                      className="btn btn-primary btn btn-secondary"
                      onClick={this.cancelar}
                    >
                      REGRESAR
                    </button>
                  </div>
                </CardFooter>
              </Card>
            </div>
          </Col>
          {this.state.opcionSeleccionada != null && (
            <Col lg={4} md={12} className="detalle-impuestos-box">
              <ValoresCotizacionAccPersonal
                primaNeta={this.props.primaNeta}
                primaTotal={this.props.primaTotal}
                metodoDescargar={this.props.metodoDescargar}
                metodoEnviar={this.props.metodoEnviar}
                sumaImpuestos={this.props.sumaImpuestos}
                paso={this.props.paso}
                impuestos={this.props.impuestos}
                linkDescarga={this.props.linkDescarga}
                okEnvio={this.props.okEnvio}
                changeVista={this.props.changeVista}
                isAP={true}
                esMasivo={(this.state.value == 'masiva' && this.state.personas.length > 0)}
                actualizarValores={this.actualizarValores}
                guardarMasivo={this.guardarMasivo}
                actualizado={this.state.actualizado}
                message={this.state.message}
                transaccion={this.state.transaccion}
                idCarrito={
                  this.state.idCarrito != undefined &&
                    this.state.idCarrito != null
                    ? this.state.idCarrito
                    : this.props.idCarrito
                }
              />
            </Col>
          )}
        </Row>
      </LoadingScreen>
    );
  }
}
const ConstVista = {
  vistaResumen: "resumen",
  vistaAgregarPersonal: "ingresoDePersonas",
  listaPrincipal: "principal",
  listaSecundaria: "secundaria",
};
const mapStateToProps = (state) => ({
  catalogo: state.catalogosHogar,
  datosAsesor: state.datosUsuarios.dataUsuario,
  carrito: state.datosCarritoHogar,
  datosIdentificacion: state.datosIdentificacionAP,
});

const mapDispatchToProps = (dispatch) => {
  return {
    setCarrito: (datosCarrito) => dispatch(FetchDataCarritoHogar(datosCarrito)),
    limpiarCarrito: () => dispatch(LimpiarCarritoHogar()),
    setProductoActual: (param) =>
      dispatch(setProductoActualCotizadoHogar(param)),
    consultarIdentificacion: (datos) =>
      dispatch(fetchConsultarIdentificacionAP(datos)),
  };
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(AgregarPersonas)
);
